import { BaseMark } from '../BaseMark.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'modeOligonKentimaAbove';
const args = {};

export class ModeOligonKentimaAbove extends BaseMark {
  constructor() {
    super(glyphname, args);
  }
}
